<script>
import MessageCardBase from '@/components/message-card-base/index';
import { trackEvent } from '@/plugins/plugin-init-omega';
import { gtrTrackCommonData } from '@/utils/gattaran-track-event';
// 获取dom的data-type，没有的话往上找2级
const findDataType = (target) => {
  let currentDom = target;
  let dataType = null;
  let i = 0;
  while (i < 2 || !currentDom) {
    i++;
    dataType = currentDom && currentDom?.getAttribute('data-type');
    if (!dataType) {
      currentDom = currentDom?.parentElement;
    } else {
      break;
    }
  }
  return dataType;
};
export default {
  name: 'MessageCenterCard',
  components: {
    MessageCardBase,
  },
  data() {
    return {
      title: '',
      content: '',
      images: [],
      contentImages: [],
      link: '',
      linkText: '',
      show: false,
      unRead: false,
      module: '',
      datetime: '',
      templateId: '',
    };
  },
  render(h) {
    return (
      <transition name="el-fade-in-linear">
        {this.show ? (
          <MessageCardBase
            onCardClick={(evt) => {
              const dataType = findDataType(evt.target);
              if (dataType) {
                const trackParams = {
                  ...gtrTrackCommonData(),
                  pre_url: window.location.href,
                  module: this.module, // 模块信息
                  current_popup: this.templateId,
                  targetElement: dataType,
                  system: 1,
                };
                trackEvent('sailing_m_gtr_popup_msg_ck', '系统公告消息卡片链接点击', trackParams);
              }
            }}
            props={{
              unRead: this.unRead,
              module: this.module,
              datetime: this.datetime,
              isCard: 1,
              title: this.title,
              content: this.content,
              images: this.images,
              contentImages: this.contentImages,
              link: this.link,
              linkText: this.linkText,
              close: () => {
                this.show = false;
              },
            }}
          />
        ) : null}
      </transition>
    );
  },
};
</script>
